import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    Dialog, DialogContent, DialogActions, Grid, TextField, Button, IconButton,
    FormControl, InputLabel, Select, MenuItem, FormHelperText,
    Paper, Typography, Box, Stepper, Step, StepLabel,
} from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import es from "date-fns/locale/es";
import moment from 'moment'
import AppBarModal from '../../../general/AppBarModal';
import { BtnForm } from '../../../general/BotonesAccion';
import TareasTerminadas from '../../../general/TareasTerminadas';
import { obtenerValores, obtenerValoresFiltros, obtenerPermisosValor, obtenerMisDatos } from "../../../../global/js/funciones";
import BuscarPersona from '../../../general/BuscarPersona';
import emma_w from '../../../../global/imagenes/emma_w.png';
import SearchIcon from '@material-ui/icons/Search';
import { TIPOS_SERV, GENERO, ORIENTACION_SEXUAL, ESTADO_CIVIL, GRUPO_PRIORIZADO, MODALIDAD_ASESORIA, EPS, TIPO_REL, DEPARTAMENTOS, OTRO_GRUPO,
    COD_CRISIS, COD_CULTURA_C, INDENTIDAD_GENERO_BIENESTAR,
    OTRA_IDENTIDAD_GENERO_BIENESTAR, OTRA_ORIENTACION_BIENESTAR,
    PARENTESCOS_BIENESTAR, COD_SOL_REM, COD_SOL_PASPE,
    CORREO_COORDINADOR_BIENESTAR, PRIORIDAD_BIENESTAR
 } from "../../helper";
import {
    fetchDatosBienestarSICUC,
    fetchDatosUsuarioBienestar,
    postCrearSolicitudBienestar,
} from '../services/bienestarDetalleService';

const configStep = ['Datos Personales', 'Datos de Contacto', 'Preferencias'];
const cardCss = { cursor: "pointer", borderRadius: 16, padding: "18px 14px", textAlign: "center", transition: "all .15s ease" };

function Personales(component_props) {
    let {
        nombre_estudiante,
        identificacion,
        celular,
        correo,
        fecha_nac,
        edad,
        onChange,
        onChangeFecha,
        conError,
        pintarSelect,
        identificacionError,
        orientacion,
        identidad_genero,
        otra_orientacion,
        otra_identidad_genero,
        bloquearFechaNac,
        bloquearGenero,
    } = component_props
    return (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            <Grid item xs={12} md={6}><TextField fullWidth label="Nombre del estudiante" value={nombre_estudiante} InputProps={{ readOnly: true }} disabled={true} /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Número de identificación" value={identificacion} InputProps={{ readOnly: true }} disabled={true} error={!!identificacionError} helperText={identificacionError || ''} /></Grid>
            <Grid item xs={12} md={6}><TextField type="number" fullWidth label="Número de celular" name="celular" value={celular.valor} onChange={onChange} error={conError(celular.error)} helperText={celular.error} /></Grid>
            <Grid item xs={12} md={6}><TextField type="email" fullWidth label="Correo electrónico" name="correo" value={correo.valor} onChange={onChange} error={conError(correo.error)} helperText={correo.error} /></Grid>
            <Grid item xs={12} md={4}>
                <FormControl className="form-control" style={{ width: "100%" }}>
                    <MuiPickersUtilsProvider locale={es} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            required
                            style={{ marginTop: 3, width: "100%" }}
                            margin="normal"
                            label="Fecha de nacimiento"
                            format="yyyy/MM/dd"
                            value={fecha_nac.valor}
                            onChange={onChangeFecha}
                            openTo="year"
                            disabled={bloquearFechaNac}
                            KeyboardButtonProps={{ "aria-label": "Cambiar fecha" }}
                            maxDate={new Date()}
                            maxDateMessage="La fecha debe ser menor que la fecha actual."
                            invalidDateMessage="Formato inválido"
                            cancelLabel="Cancelar"
                            okLabel="Aceptar"
                            todayLabel="Hoy"
                            InputProps={{
                                readOnly: bloquearFechaNac,
                                onClick: () => {
                                    if (bloquearFechaNac) return;
                                    const btn = document.querySelector('button[aria-label="Cambiar fecha"]');
                                    if (btn) btn.click();
                                }
                            }}
                            TextFieldComponent={(props) => (
                                <TextField
                                    {...props}
                                    fullWidth
                                    error={Boolean(fecha_nac.error)}
                                    helperText={fecha_nac.error || ""}
                                />
                            )}
                        />
                    </MuiPickersUtilsProvider>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={2}><TextField fullWidth label="Edad" value={fecha_nac.valor ? `${edad.valor} años` : "Escoja Fecha"} InputProps={{ readOnly: true }} disabled={true} /></Grid>
            <Grid item xs={12} md={6}>{pintarSelect("Sexo biológico", "genero", bloquearGenero)}</Grid>
            <Grid item xs={12} md={6}>{pintarSelect("Orientación sexual", "orientacion")}</Grid>
            {orientacion.valor == OTRA_ORIENTACION_BIENESTAR && (<Grid item xs={12} md={6}><TextField fullWidth label="Especifique su orientación sexual" name="otra_orientacion"  value={otra_orientacion.valor} onChange={onChange} error={conError(otra_orientacion.error)} helperText={otra_orientacion.error} /></Grid> )}
            <Grid item xs={12} md={6}>{pintarSelect("Identidad de género", "identidad_genero")}</Grid>
            {identidad_genero.valor == OTRA_IDENTIDAD_GENERO_BIENESTAR && (<Grid item xs={12} md={6}><TextField fullWidth label="Especifique su identidad de género" name="otra_identidad_genero" value={otra_identidad_genero.valor} onChange={onChange} error={conError(otra_identidad_genero.error)} helperText={otra_identidad_genero.error} /></Grid> )}
        </Grid>
    )
}

function Contacto(component_props) {
    let {
        direccion,
        barrio,
        lugar_procedencia,
        onChange,
        conError,
        sisben_opciones,
        estado_civil,
        estado_civil_opciones,
        pintarSelect,
        pintarSelectOpciones,
        grupo_priorizado,
        otro_grupo
    } = component_props
    return (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            <Grid item xs={12} md={6}><FormControl className="form-control" error={conError(estado_civil.error)}>
                <InputLabel>Estado civil</InputLabel>
                <Select value={estado_civil.valor || ""} onChange={onChange} name={"estado_civil"}>
                    {estado_civil_opciones.map(op => <MenuItem key={op.value} value={op.label}>{op.label}</MenuItem>)}
                </Select>
                {estado_civil.error && <FormHelperText>{estado_civil.error}</FormHelperText>}
            </FormControl>
            </Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Dirección actual" name="direccion" value={direccion.valor} onChange={onChange} error={conError(direccion.error)} helperText={direccion.error} /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Barrio" name="barrio" value={barrio.valor} onChange={onChange} error={conError(barrio.error)} helperText={barrio.error} /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Lugar procedencia" name="lugar_procedencia" value={lugar_procedencia.valor} onChange={onChange} error={conError(lugar_procedencia.error)} helperText={lugar_procedencia.error} /></Grid>
            <Grid item xs={12} md={6}>{pintarSelect("Departamento", "departamento")}</Grid>
            <Grid item xs={12} md={6}>{pintarSelect("Municipio", "ciudad")}</Grid>
            <Grid item xs={12} md={6}>{pintarSelect("EPS", "eps")}</Grid>
            <Grid item xs={12} md={6}>{pintarSelectOpciones("Sisbén", "sisben", sisben_opciones)}</Grid>
            <Grid item xs={12}>{pintarSelect("¿Pertenece a algún grupo priorizado?", "grupo_priorizado")}</Grid>
            {grupo_priorizado.valor == OTRO_GRUPO && (<Grid item xs={12}><TextField fullWidth label="¿Cuál?" name="otro_grupo"  value={otro_grupo.valor} onChange={onChange} error={conError(otro_grupo.error)} helperText={otro_grupo.error} /></Grid> )}
        </Grid>
    )
}

function Preferencias(component_props) {
    let {
        semestre,
        motivo,
        hora_i_1,
        hora_f_1,
        hora_i_2,
        hora_f_2,
        dia_semana_opciones,
        sesiones_opciones,
        onChange,
        onChangeTime,
        conError,
        pintarSelect,
        pintarSelectOpciones,
        contacto_emergencia,
        nombre_contacto_emergencia,
        parentesco,
    } = component_props
    return (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            <Grid item xs={12} md={6}>{pintarSelect("Programa Academico", "programa")}</Grid>
            <Grid item xs={12} md={6}><TextField type="number" fullWidth label="Semestre" name="semestre" value={semestre.valor} onChange={onChange} inputProps={{ min: 1, max: 10, step: 1 }} error={conError(semestre.error)} helperText={semestre.error} /></Grid>
            <Grid item xs={12} style={{'paddingBottom': '0'}}><Typography variant="subtitle2" style={{'fontWeight': '700'}}>Indique un día de la semana y el horario que disponga semanalmente para recibir las asesorías (Ej: Martes de 8:00 a 11:00 am)</Typography></Grid>
            <Grid item xs={12} md={4}>{pintarSelectOpciones("Dia semana", "dia_1", dia_semana_opciones)}</Grid>
            <Grid item xs={12} md={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                    <Grid container>
                        <KeyboardTimePicker
                            required={true}
                            style={{ marginTop: 3, width: '100%' }}
                            margin="normal"
                            name="hora_i_1"
                            label="Hora Inicio"
                            value={hora_i_1.valor}
                            onChange={(time) => onChangeTime(time, "hora_i_1")}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage='Formato Invalido'
                            TextFieldComponent={(props) => (
                                <TextField
                                    {...props}
                                    fullWidth
                                    error={Boolean(hora_i_1.error)}
                                    helperText={hora_i_1.error || ""}
                                />
                            )}
                        />
                    </Grid>
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                    <Grid container >
                        <KeyboardTimePicker
                            required={true}
                            style={{ marginTop: 1, width: '100%' }}
                            margin="normal"
                            label="Hora Fin"
                            name="hora_f_1"
                            value={hora_f_1.valor}
                            onChange={(time) => onChangeTime(time, "hora_f_1")}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage='Formato Invalido'
                            TextFieldComponent={(props) => (
                                <TextField
                                    {...props}
                                    fullWidth
                                    error={Boolean(hora_f_1.error)}
                                    helperText={hora_f_1.error || ""}
                                />
                            )}
                        />
                    </Grid>
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} style={{'paddingBottom': '0'}}><Typography variant="subtitle2" style={{'fontWeight': '700'}}>Indique una segunda opción de horario en el que pueda recibir las asesorías semanalmente(Ej: jueves de 3:00 a 6:00 pm)</Typography></Grid>
            <Grid item xs={12} md={4}>{pintarSelectOpciones("Dia semana", "dia_2", dia_semana_opciones)}</Grid>
            <Grid item xs={12} md={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                    <Grid container>
                        <KeyboardTimePicker
                            required={true}
                            style={{ marginTop: 3, width: '100%' }}
                            margin="normal"
                            name="hora_i_2"
                            label="Hora Inicio"
                            value={hora_i_2.valor}
                            onChange={(time) => onChangeTime(time, "hora_i_2")}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage='Formato Invalido'
                            TextFieldComponent={(props) => (
                                <TextField
                                    {...props}
                                    fullWidth
                                    error={Boolean(hora_i_2.error)}
                                    helperText={hora_i_2.error || ""}
                                />
                            )}
                        />
                    </Grid>
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12} md={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                    <Grid container >
                        <KeyboardTimePicker
                            required={true}
                            style={{ marginTop: 1, width: '100%' }}
                            margin="normal"
                            label="Hora Fin"
                            name="hora_f_2"
                            value={hora_f_2.valor}
                            onChange={(time) => onChangeTime(time, "hora_f_2")}
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            invalidDateMessage='Formato Invalido'
                            TextFieldComponent={(props) => (
                                <TextField
                                    {...props}
                                    fullWidth
                                    error={Boolean(hora_f_2.error)}
                                    helperText={hora_f_2.error || ""}
                                />
                            )}
                        />
                    </Grid>
                </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={6}>{pintarSelect("¿En qué modalidad prefieres las asesorías?", "modalidad")}</Grid>
            <Grid item xs={12} md={6}>{pintarSelectOpciones("¿Cuántas sesiones prefieres?", "sesiones", sesiones_opciones)}</Grid>
            <Grid item xs={12}><TextField fullWidth multiline rows={4} label="Escribe el motivo de tu asesoría" name="motivo" value={motivo.valor} onChange={onChange} error={conError(motivo.error)} helperText={motivo.error} /></Grid>
            <Grid item xs={12}><TextField type="text" fullWidth label="Nombre del contacto de emergencia" name="nombre_contacto_emergencia" value={nombre_contacto_emergencia.valor} onChange={onChange} error={conError(nombre_contacto_emergencia.error)} helperText={nombre_contacto_emergencia.error} /></Grid>
            <Grid item xs={12} md={6}><TextField type="number" fullWidth label="Número de contacto de emergencia" name="contacto_emergencia" value={contacto_emergencia.valor} onChange={onChange} error={conError(contacto_emergencia.error)} helperText={contacto_emergencia.error} /></Grid>
            <Grid item xs={12} md={6}>{pintarSelect("Parentesco contacto de emergencia", "parentesco")}</Grid>
        </Grid>
    )
}

function ItemCard({ item, onClick }) {
    const letra = String(item.nombre || "?").trim().charAt(0).toUpperCase();
    const avatarImg = item?.archivo || item?.imagen || '';
    return (
        <Paper elevation={4} style={cardCss} onClick={() => onClick(item)}>
            {avatarImg ? (
                <img
                    src={avatarImg}
                    alt={item?.nombre || 'Tipo de servicio'}
                    style={{ width: 72, height: 72, objectFit: 'contain', marginBottom: 8 }}
                />
            ) : (
                <Box
                    style={{
                        width: 64, height: 64, borderRadius: "50%",
                        background: "rgba(244, 67, 54, 0.1)", display: "inline-flex",
                        alignItems: "center", justifyContent: "center",
                        fontWeight: 700, color: "rgb(244, 67, 54)", marginBottom: 8,
                    }}
                >
                    {letra}
                </Box>
            )}
            <Typography variant="body1" style={{ fontWeight: 600, textTransform: "uppercase" }}>
                {item.nombre}
            </Typography>
            <Typography variant="body8" style={{ fontWeight: 500 }}>
                { item.descripcion && item.descripcion.charAt(0).toUpperCase() + item.descripcion.slice(1).toLowerCase() }
            </Typography>
        </Paper>
    );
}

class BienestarFormAgregar extends Component {
    enviandoFormulario = false;
    constructor(props) {
        super(props)
        this.sicucDatosBienestar = null;
        this.state = {
            step: "select",
            activeStep: -1,
            cargando: true,
            cargar: true,
            titulo_car: 'Cargando..',
            tiposServicio: [],
            tipoServicioSel: null,
            nombre_estudiante: "",
            identificacion: "",
            identificacionError: '',
            celular: { valor: "" },
            correo: { valor: "" },
            contacto_emergencia: { valor: "" },
            fecha_nac: { valor: null },
            edad: { valor: "" },
            genero: { valor: "" },
            orientacion: { valor: "" },
            identidad_genero: { valor: "" },
            otra_orientacion: { valor: "" },
            otra_identidad_genero: { valor: "" },
            nombre_contacto_emergencia: { valor: "" },
            estado_civil: { valor: "" },
            direccion: { valor: "" },
            barrio: { valor: "" },
            lugar_procedencia: { valor: "" },
            ciudad: { valor: "" },
            departamento: { valor: "" },
            eps: { valor: "" },
            sisben: { valor: "" },
            grupo_priorizado: { valor: "" },
            otro_grupo: { valor: "" },
            programa: { valor: "" },
            semestre: { valor: "" },
            dia_1: { valor: "" },
            hora_i_1: { valor: null },
            hora_f_1: { valor: null },
            dia_2: { valor: "" },
            hora_i_2: { valor: null },
            hora_f_2: { valor: null },
            modalidad: { valor: "" },
            sesiones: { valor: "" },
            motivo: { valor: "" },
            nombre_remitente: { valor: "" },
            openBuscarEstudiante: false,
            openConfirmarCopiaCoordinador: false,
            estudiante_seleccionado: null,
            relacion: { valor: "" },
            nivel_prioridad: { valor: "" },
            parentesco: { valor: "" },
            programa_opciones: [],
            genero_opciones: [],
            orientacion_opciones: [],
            identidad_genero_opciones: [],
            estado_civil_opciones: [],
            grupo_priorizado_opciones: [],
            modalidad_opciones: [],
            eps_opciones: [],
            relacion_opciones: [],
            nivel_prioridad_opciones: [],
            parentesco_opciones: [],
            departamento_opciones: [],
            ciudad_opciones: [],
            sisben_opciones: ["SI", "NO"],
            dia_semana_opciones: ["LUNES", "MARTES", "MIERCOLES", "JUEVES", "VIERNES", "SABADO"],
            sesiones_opciones: [1, 4],
            bloquearFechaNac: false,
            bloquearGenero: false,
        }
    }


    async componentDidUpdate(prevProps, prevState) {
        const { modalAddBienestar, tipoSolicitud } = this.props;
        const { activeStep, departamento, cargar, tipoServicioSel } = this.state;

        if (prevProps.modalAddBienestar !== modalAddBienestar) {
            if (modalAddBienestar) {
                this.resetState();
                this.setState({ step: "select", activeStep: -1, cargando: true });
                if (tipoSolicitud?.codigo === COD_SOL_PASPE) {
                const resp = await fetchDatosBienestarSICUC();
                const fila = Array.isArray(resp) && resp.length ? resp[0] : null;
                this.sicucDatosBienestar = {
                    genero: Array.isArray(fila) ? (fila[5] || "") : "",
                    fecha_nac: Array.isArray(fila) ? (fila[7] || "") : "",
                    edad: Array.isArray(fila) ? fila[16] : "",
                };
                
                }
                const tiposServicio = await obtenerValoresFiltros([
                    { llave: "generica", valor: TIPOS_SERV },
                    { llave: "estado", valor: "1" }
                ]);
                this.setState({ tiposServicio, cargando: false });
            } else {
                this.sicucDatosBienestar = null;
                this.resetState();
            }
        }

        if (prevState.tipoServicioSel !== tipoServicioSel && tipoServicioSel) {
            const esCrisisOCultura = [COD_CRISIS, COD_CULTURA_C].includes(tipoServicioSel.codigo);
            this.setState({
                sesiones_opciones: esCrisisOCultura ? [1] : [1, 4],
                sesiones: esCrisisOCultura ? { valor: 1 } : { valor: "" }
            });
        }

        if (prevState.activeStep !== activeStep && activeStep == 0 && cargar) {
            this.setState({ cargando: true, titulo_car: 'Cargando Formulario..' });
            const misDatos = await this.datosUsuarioBienestar();
            const parentescos = await obtenerValores(PARENTESCOS_BIENESTAR);

            const baseState = {
                nombre_estudiante: misDatos.primer_apellido
                    ? `${misDatos.primer_nombre} ${misDatos.primer_apellido} ${misDatos.segundo_apellido}`
                    : "",
                identificacion: misDatos?.identificacion || "",
                celular: { valor: misDatos?.celular || "" },
                correo: { valor: misDatos?.correo_personal || "" },
                programa_opciones: misDatos.programas.map((prog) => ({
                    value: prog.id_relacion,
                    label: prog.nombre_relacion,
                })),
                parentesco_opciones: this.transformar(parentescos),
                parentesco: { valor: "" },
            };

            let nuevoEstado = {};

            if (tipoSolicitud.codigo === COD_SOL_REM) {
                const relaciones = await obtenerValores(TIPO_REL);
                const prioridades = await obtenerValores(PRIORIDAD_BIENESTAR);
                nuevoEstado = {
                    ...baseState,
                    nombre_estudiante: "",
                    identificacion: "",
                    estudiante_seleccionado: null,
                    nombre_remitente: { valor: baseState.nombre_estudiante },
                    celular: { valor: "" },
                    correo: { valor: "" },
                    relacion_opciones: this.transformar(relaciones),
                    nivel_prioridad_opciones: this.transformar(prioridades),
                    nivel_prioridad: { valor: "" },
                    programa_opciones: [],
                    programa: { valor: "" },
                };
            } else if (tipoSolicitud.codigo === COD_SOL_PASPE && tipoServicioSel?.codigo !== COD_CRISIS) {
                const generos = await obtenerValores(GENERO);
                const orientaciones = await obtenerValores(ORIENTACION_SEXUAL);
                const identidad_genero = await obtenerValores(INDENTIDAD_GENERO_BIENESTAR);
                const estadosc = await obtenerValores(ESTADO_CIVIL);
                const gruposp = await obtenerValores(GRUPO_PRIORIZADO);
                const modalidades = await obtenerValores(MODALIDAD_ASESORIA);
                const epsOpciones = await obtenerValores(EPS);
                const departamentos = await obtenerValores(DEPARTAMENTOS);
                const sicuc = this.sicucDatosBienestar || {};
                const fechaSicuc = String(sicuc.fecha_nac || "").trim();
                const generoSicuc = String(sicuc.genero || "").trim();
                const edadSicuc = sicuc.edad !== undefined && sicuc.edad !== null
                    ? String(sicuc.edad)
                    : "";
                const generoOpciones = this.transformar(generos);
                const generoSicucCodigo = generoSicuc.toUpperCase();
                const generoSicucLabel = generoSicucCodigo === "M"
                    ? "MASCULINO"
                    : generoSicucCodigo === "F"
                        ? "FEMENINO"
                        : "";
                const generoSicucValor = generoSicucLabel
                    ? (generoOpciones.find((op) => String(op.label || "").toUpperCase() === generoSicucLabel)?.value || "")
                    : "";
                const fechaBase = fechaSicuc || misDatos.fecha_nacimiento || "";
                const fechaMomentBase = fechaBase
                    ? moment(fechaBase, ["YYYY-MM-DD", moment.ISO_8601])
                    : null;
                const fechaMoment = fechaMomentBase && fechaMomentBase.isValid()
                    ? fechaMomentBase
                    : null;

                nuevoEstado = {
                    ...baseState,
                    fecha_nac: { valor: fechaMoment },
                    edad: { valor: edadSicuc || (fechaMoment ? this.calcularEdad(fechaMoment.toDate()) : "") },
                    genero: { valor: generoSicucValor || misDatos?.genero || "" },
                    orientacion: { valor: misDatos?.orientacion_sexual || "" },
                    identidad_genero: { valor: misDatos?.identidad_genero || "" },
                    estado_civil: { valor: misDatos?.estado_civil || "" },
                    direccion: { valor: misDatos?.direccion || "" },
                    barrio: { valor: misDatos?.lugar_residencia || "" },
                    departamento: { valor: misDatos?.departamento || "" },
                    ciudad: { valor: misDatos?.ciudad || "" },
                    eps: { valor: misDatos?.eps || "" },
                    bloquearFechaNac: !!fechaSicuc,
                    bloquearGenero: !!generoSicucValor,
                    genero_opciones: generoOpciones,
                    orientacion_opciones: this.transformar(orientaciones),
                    identidad_genero_opciones: this.transformar(identidad_genero),
                    estado_civil_opciones: this.transformar(estadosc),
                    grupo_priorizado_opciones: this.transformar(gruposp),
                    modalidad_opciones: this.transformar(modalidades),
                    eps_opciones: this.transformar(epsOpciones),
                    departamento_opciones: this.transformar(departamentos),
                };
            } else {
                nuevoEstado = { ...baseState };
            }

            this.setState({
                ...nuevoEstado,
                cargar: false,
                cargando: false,
            });
        }

        if (prevState.departamento.valor !== departamento.valor) {
            this.setState({ cargando: true });
            let ciudades = await obtenerPermisosValor(departamento.valor);
            ciudades = ciudades.map(({ secundario }) => ({
                value: secundario.id,
                label: secundario.nombre,
            }));
            this.setState({ cargando: false, ciudad_opciones: ciudades });
        }
    }


    resetState = () => {
        this.enviandoFormulario = false;
        this.setState({
            step: "select",
            activeStep: -1,
            cargando: true,
            cargar: true,
            titulo_car: 'Cargando..',
            tiposServicio: [],
            tipoServicioSel: null,
            nombre_estudiante: "",
            identificacion: "",
            celular: { valor: "" },
            correo: { valor: "" },
            contacto_emergencia: { valor: "" },
            nombre_contacto_emergencia: { valor: "" },
            fecha_nac: { valor: null },
            edad: { valor: "" },
            genero: { valor: "" },
            orientacion: { valor: "" },
            identidad_genero: { valor: "" },
            otra_orientacion: { valor: "" },
            otra_identidad_genero: { valor: "" },
            estado_civil: { valor: "" },
            direccion: { valor: "" },
            barrio: { valor: "" },
            lugar_procedencia: { valor: "" },
            ciudad: { valor: "" },
            departamento: { valor: "" },
            eps: { valor: "" },
            sisben: { valor: "" },
            grupo_priorizado: { valor: "" },
            otro_grupo: { valor: "" },
            programa: { valor: "" },
            semestre: { valor: "" },
            dia_1: { valor: "" },
            hora_i_1: { valor: null },
            hora_f_1: { valor: null },
            dia_2: { valor: "" },
            hora_i_2: { valor: null },
            hora_f_2: { valor: null },
            modalidad: { valor: "" },
            sesiones: { valor: "" },
            motivo: { valor: "" },
            nombre_remitente: { valor: "" },
            relacion: { valor: "" },
            nivel_prioridad: { valor: "" },
            parentesco: { valor: "" },
            openBuscarEstudiante: false,
            openConfirmarCopiaCoordinador: false,
            estudiante_seleccionado: null,
            identificacionError: '',
            parentesco_opciones: [],
            nivel_prioridad_opciones: [],
            bloquearFechaNac: false,
            bloquearGenero: false,
        })
    }


    datosUsuarioBienestar = () => {
        return fetchDatosUsuarioBienestar();
    };


    transformar = (data, id = 'id', nombre = 'nombre') => {
        return data.map((e) => ({
            value: e[id],
            label: e[nombre]
        }));
    };

    renderSelectGrid = () => {
        const { cargando, tiposServicio } = this.state;
        if (cargando) return <TareasTerminadas mensaje="Cargando..." marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true} />;
        return (
            <Grid container spacing={3} style={{ paddingTop: 10 }}>
                {tiposServicio.map((t) => (
                    <Grid key={t.codigo || t.id || t.nombre} item xs={12} sm={6} md={4}>
                        <ItemCard item={t} onClick={(item) => this.setState({ tipoServicioSel: item, activeStep: 0 })} />
                    </Grid>
                ))}
                {!tiposServicio.length && (
                    <Grid item xs={12}><Typography align="center" color="textSecondary">No hay tipos disponibles.</Typography></Grid>
                )}
            </Grid>
        );
    };

    onChange = ({ target }) => {
        let { value, name } = target;
        this.setState({
            [name]: { valor: value }
        })
    }

    onChangeFecha = (date) => this.setState({ fecha_nac: { valor: date }, edad: { valor: this.calcularEdad(date) } });
    onChangeTime = (time, nombre) => this.setState({ [nombre]: { valor: time } })
    calcularEdad = (d) => {
        if (!d) return "";
        const hoy = new Date();
        let e = hoy.getFullYear() - d.getFullYear();
        const m = hoy.getMonth() - d.getMonth();
        if (m < 0 || (m === 0 && hoy.getDate() < d.getDate())) e--;
        return String(Math.max(0, e));
    };

    conError = (msg) => !!msg;

    handleNext = () => {
        let { activeStep } = this.state
        if (this.validateStep(activeStep)) return;
        this.setState(({ activeStep }) => ({ activeStep: Math.min(2, activeStep + 1) }));
    };
    handleBack = () => this.setState(({ activeStep }) => ({ activeStep: Math.max(0, activeStep - 1) }));

    mapSimple = (arr = []) => arr.map(op => ({ id: op.id ?? op.value, nombre: op.nombre ?? op.label }));


    pintarSelect = (label, name, disabled = false) => (
        <FormControl className="form-control" error={this.conError(this.state[name].error)}>
            <InputLabel>{label}</InputLabel>
            <Select value={this.state[name].valor || ""} onChange={this.onChange} name={name} disabled={disabled}>
                {this.mapSimple(this.state[`${name}_opciones`]).map(op => <MenuItem key={op.id} value={op.id}>{op.nombre}</MenuItem>)}
            </Select>
            {this.state[name].error && <FormHelperText>{this.state[name].error}</FormHelperText>}
        </FormControl>
    )

    pintarSelectOpciones = (label, name, opciones) => (
        <FormControl className="form-control" style={{ marginTop: '4px' }} error={this.conError(this.state[name].error)}>
            <InputLabel>{label}</InputLabel>
            <Select
                value={this.state[name].valor || ""}
                onChange={this.onChange}
                name={name}
                disabled={opciones.length === 1}
            >
                {(opciones).map((op, i) => <MenuItem key={i} value={op}>{op}</MenuItem>)}
            </Select>
            {this.state[name].error && <FormHelperText>{this.state[name].error}</FormHelperText>}
        </FormControl>
    );

    req = (estadoObj, clave, errorFlag) => {
        const obligatorio = "Este campo es obligatorio";
        const campo = estadoObj[clave] || {};
        if (!campo.valor) {
            estadoObj[clave].error = obligatorio;
            errorFlag.value = true;
        } else {
            estadoObj[clave].error = "";
        }
    };

    reqNum = (estadoObj, clave, errorFlag) => {
        const numero = "Este campo debe ser un número";
        this.req(estadoObj, clave, errorFlag);
        if (estadoObj[clave].valor !== "" && isNaN(Number(estadoObj[clave].valor))) {
            estadoObj[clave].error = numero;
            errorFlag.value = true;
        }
    };

    reqHora = (estadoObj, claveInicio, claveFin, errorFlag) => {
        const obligatorio = "Este campo es obligatorio";

        estadoObj[claveFin].error = "";
        const inicio = estadoObj[claveInicio].valor;
        const fin = estadoObj[claveFin].valor;

        if (!inicio && !fin) {
            estadoObj[claveInicio].error = obligatorio;
            estadoObj[claveFin].error = obligatorio;
            errorFlag.value = true;
            return false;
        }

        if (!inicio) {
            estadoObj[claveInicio].error = obligatorio;
            errorFlag.value = true;
            return false;
        }

        if (!fin) {
            estadoObj[claveFin].error = obligatorio;
            errorFlag.value = true;
            return false;
        }

        if (inicio && fin && new Date(fin) <= new Date(inicio)) {
            estadoObj[claveFin].error = "La hora fin debe ser mayor que la hora inicio";
            estadoObj[claveFin].valor = null;
            errorFlag.value = true;
        }
        return true;
    };


    validateStep = (stepIndex) => {
        const errorFlag = { value: false };
        const estadoObj = { ...this.state };
        const { orientacion, identidad_genero, grupo_priorizado } = estadoObj;

        if (stepIndex === 0) {
            this.reqNum(estadoObj, "celular", errorFlag);
            this.req(estadoObj, "correo", errorFlag);
            this.req(estadoObj, "fecha_nac", errorFlag);
            this.req(estadoObj, "genero", errorFlag);
            this.req(estadoObj, "orientacion", errorFlag);
            this.req(estadoObj, "identidad_genero", errorFlag);
            if (orientacion.valor == OTRA_ORIENTACION_BIENESTAR) { this.req(estadoObj, "otra_orientacion", errorFlag); }
            if (identidad_genero.valor == OTRA_IDENTIDAD_GENERO_BIENESTAR) { this.req(estadoObj, "otra_identidad_genero", errorFlag); }
        } else if (stepIndex === 1) {
            this.req(estadoObj, "estado_civil", errorFlag);
            this.req(estadoObj, "direccion", errorFlag);
            this.req(estadoObj, "barrio", errorFlag);
            this.req(estadoObj, "lugar_procedencia", errorFlag);
            this.req(estadoObj, "ciudad", errorFlag);
            this.req(estadoObj, "departamento", errorFlag);
            this.req(estadoObj, "eps", errorFlag);
            this.req(estadoObj, "sisben", errorFlag);
            this.req(estadoObj, "grupo_priorizado", errorFlag);
            if (grupo_priorizado.valor == OTRO_GRUPO) {this.req(estadoObj, "otro_grupo", errorFlag); }
        } else if (stepIndex === 2) {
            this.req(estadoObj, "programa", errorFlag);
            this.reqNum(estadoObj, "semestre", errorFlag);
            this.req(estadoObj, "dia_1", errorFlag);
            this.reqHora(estadoObj, "hora_i_1", "hora_f_1", errorFlag)
            this.req(estadoObj, "dia_2", errorFlag);
            this.reqHora(estadoObj, "hora_i_2", "hora_f_2", errorFlag)
            this.req(estadoObj, "modalidad", errorFlag);
            this.req(estadoObj, "sesiones", errorFlag);
            this.req(estadoObj, "motivo", errorFlag);
            this.req(estadoObj, "contacto_emergencia", errorFlag);
            this.req(estadoObj, "nombre_contacto_emergencia", errorFlag);
            this.req(estadoObj, "parentesco", errorFlag);
        }
        this.setState(estadoObj);
        return errorFlag.value;
    };

    validarSubmit = () => {
        let { tipoSolicitud } = this.props;
        let { tipoServicioSel, identificacion } = this.state

        if (tipoSolicitud.codigo == COD_SOL_REM) {
            const errorFlag = { value: false };
            const estadoObj = { ...this.state };
            this.reqNum(estadoObj, "celular", errorFlag);
            this.req(estadoObj, "correo", errorFlag);
            this.req(estadoObj, "relacion", errorFlag);
            this.req(estadoObj, "nivel_prioridad", errorFlag);
            this.req(estadoObj, "nombre_remitente", errorFlag);
            if (!identificacion || identificacion === '') {
                estadoObj.identificacionError = 'Este campo es obligatorio';
                errorFlag.value = true;
            } else {
                estadoObj.identificacionError = '';
            }
            this.req(estadoObj, "motivo", errorFlag);
            this.req(estadoObj, "programa", errorFlag);
            this.setState(estadoObj);
            return errorFlag.value;
        } else if (tipoSolicitud.codigo == COD_SOL_PASPE && tipoServicioSel.codigo == COD_CRISIS) {
            const errorFlag = { value: false };
            const estadoObj = { ...this.state };
            this.reqNum(estadoObj, "celular", errorFlag);
            this.req(estadoObj, "correo", errorFlag);
            this.req(estadoObj, "contacto_emergencia", errorFlag);
            this.req(estadoObj, "nombre_contacto_emergencia", errorFlag);
            this.req(estadoObj, "parentesco", errorFlag);
            this.req(estadoObj, "programa", errorFlag);
            this.req(estadoObj, "motivo", errorFlag);
            this.setState(estadoObj);
            return errorFlag.value;
        } else {
            return (this.validateStep(2))
        }
    }

    onSubmit = async () => {
        if (this.enviandoFormulario || this.state.cargando) return;
        const { tipoSolicitud } = this.props;
        if (this.validarSubmit()) return;
        if (tipoSolicitud.codigo === COD_SOL_REM) {
            this.setState({ openConfirmarCopiaCoordinador: true });
            return;
        }
        this.enviarSolicitud(false);
    };

    confirmarGuardarConCopia = () => {
        this.setState(
            { openConfirmarCopiaCoordinador: false },
            () => this.enviarSolicitud(true)
        );
    };

    guardarSinCopia = () => {
        this.setState(
            { openConfirmarCopiaCoordinador: false },
            () => this.enviarSolicitud(false)
        );
    };

    enviarSolicitud = async (enviarCopia = false) => {
        if (this.enviandoFormulario || this.state.cargando) return;
        this.enviandoFormulario = true;
        let { actualizarMensaje, mostrarModalAddBienestar, tipoSolicitud } = this.props;
        let { tipoServicioSel, celular, correo, contacto_emergencia, nombre_contacto_emergencia, parentesco, programa, motivo,
            relacion, nombre_remitente, nombre_estudiante, identificacion, fecha_nac, edad, genero, orientacion, identidad_genero,
            otra_orientacion, otra_identidad_genero, estado_civil, direccion, barrio, lugar_procedencia, ciudad, departamento, eps, sisben, nivel_prioridad,
            grupo_priorizado, otro_grupo, semestre, estudiante_seleccionado, dia_1, hora_i_1, hora_f_1, dia_2, hora_i_2, hora_f_2, modalidad, sesiones
        } = this.state
        let datos = {
            tipoSolicitud: tipoSolicitud.id,
            tipoServicioSel: tipoServicioSel.id,
            celular: celular.valor,
            correo: correo.valor,
            contacto_emergencia: contacto_emergencia.valor,
            nombre_contacto_emergencia: nombre_contacto_emergencia.valor,
            parentesco: parentesco.valor,
            programa: programa.valor,
            motivo: motivo.valor,
            correo_coordinador_generica: CORREO_COORDINADOR_BIENESTAR,
        };

        if (tipoSolicitud.codigo == COD_SOL_REM) {
                Object.assign(datos, {
                    relacion: relacion.valor,
                    nivel_prioridad: nivel_prioridad.valor,
                    nombre_remitente: nombre_remitente.valor,
                    enviar_copia: !!enviarCopia,
                    nombre_estudiante: nombre_estudiante,
                    identificacion: identificacion,
                    fecha_nac: fecha_nac.valor
                        ? moment(fecha_nac.valor).format("YYYY-MM-DD")
                        : "",
                    edad: edad.valor,
                    genero: genero.valor,
                    orientacion: orientacion.valor,
                    otra_orientacion: otra_orientacion.valor,
                    identidad_genero: identidad_genero.valor,
                    otra_identidad_genero: otra_identidad_genero.valor,
                    estado_civil: estado_civil.valor,
                    direccion: direccion.valor,
                    barrio: barrio.valor,
                    lugar_procedencia: lugar_procedencia.valor,
                    ciudad: ciudad.valor,
                    departamento: departamento.valor,
                    eps: eps.valor,
                    sisben: sisben.valor === "SI" ? 1 : 0,
                    grupo_priorizado: grupo_priorizado.valor,
                    otro_grupo: otro_grupo.valor,
                    semestre: semestre.valor,
                    estudiante_id: estudiante_seleccionado ? (estudiante_seleccionado.id || estudiante_seleccionado) : null,
                });
        }else if (tipoSolicitud.codigo == COD_SOL_PASPE && tipoServicioSel.codigo != COD_CRISIS) {
            Object.assign(datos, {
                fecha_nac: fecha_nac.valor
                    ? moment(fecha_nac.valor).format("YYYY-MM-DD")
                    : "",
                edad: edad.valor,
                genero: genero.valor,
                orientacion: orientacion.valor,
                otra_orientacion: otra_orientacion.valor,
                identidad_genero: identidad_genero.valor,
                otra_identidad_genero: otra_identidad_genero.valor,
                estado_civil: estado_civil.valor,
                direccion: direccion.valor,
                barrio: barrio.valor,
                lugar_procedencia: lugar_procedencia.valor,
                ciudad: ciudad.valor,
                departamento: departamento.valor,
                eps: eps.valor,
                sisben: sisben.valor === "SI" ? 1 : 0,
                grupo_priorizado: grupo_priorizado.valor,
                otro_grupo: otro_grupo.valor,
                semestre: semestre.valor,
                dia_1: dia_1.valor,
                hora_1: `${hora_i_1.valor ? moment(hora_i_1.valor).format("HH:mm") : ""} - ${hora_f_1.valor ? moment(hora_f_1.valor).format("HH:mm") : ""}`,
                dia_2: dia_2.valor,
                hora_2: `${hora_i_2.valor ? moment(hora_i_2.valor).format("HH:mm") : ""} - ${hora_f_2.valor ? moment(hora_f_2.valor).format("HH:mm") : ""}`,
                modalidad: modalidad.valor,
                sesiones: sesiones.valor,
            })
        }

        Object.keys(datos).forEach(key => {
            if (datos[key] === "" || datos[key] === null) {
                delete datos[key];
            }
        });

        try {
            this.setState({ cargando: true, titulo_car: 'Enviando..' });
            const { error, estado, resp } = await postCrearSolicitudBienestar(datos);
            let tipo = 'error', titulo = 'Ha ocurrido un error.';
            if (!error) {
                if (estado === 201) {
                    tipo = 'success'; titulo = resp?.titulo || 'Solicitud creada.';
                    mostrarModalAddBienestar(false);
                }
                else if (estado === 302) { tipo = 'info'; titulo = resp?.titulo || 'Información'; }
                else { tipo = 'info'; titulo = resp?.titulo || 'No se pudo completar la acción.'; }
            }
            actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
            this.setState({ cargando: false, titulo_car: 'Cargando..' });
            this.enviandoFormulario = false;
        } catch (e) {
            this.setState({ cargando: false, titulo_car: 'Cargando..' });
            this.enviandoFormulario = false;
            actualizarMensaje({ titulo: 'Error al procesar la solicitud.', tipo: 'danger', mostrar: true, tiempo: 6000 });
        }
    };


    pintarFormulario = () => {
        let { tipoSolicitud } = this.props
        let { tipoServicioSel } = this.state
        if (tipoSolicitud.codigo == COD_SOL_REM) {
            return this.formRemision()
        } else {
            if (tipoServicioSel.codigo === COD_CRISIS) return this.formEstudianteCrisis()
            else return this.formEstudiantePrincipal()
        }
    }


    formEstudiantePrincipal = () => {
        let { activeStep, nombre_estudiante, identificacion, celular, correo, contacto_emergencia, fecha_nac, edad, lugar_procedencia, direccion, barrio, semestre, horario_1, horario_2, modalidad,
            sesiones, motivo, dia_1, hora_i_1, hora_f_1, dia_2, hora_i_2, hora_f_2, dia_semana_opciones, sesiones_opciones, sisben_opciones, estado_civil, estado_civil_opciones, nombre_contacto_emergencia, parentesco,
            orientacion, identidad_genero, otra_orientacion, otra_identidad_genero, identificacionError, grupo_priorizado, otro_grupo, bloquearFechaNac, bloquearGenero } = this.state

        switch (activeStep) {
            case 0:
                return (
                    <Personales
                        {...{
                            nombre_estudiante,
                            identificacion,
                            celular,
                            correo,
                            fecha_nac,
                            edad,
                            orientacion,
                            identidad_genero,
                            otra_orientacion,
                            otra_identidad_genero,
                            identificacionError,
                            bloquearFechaNac,
                            bloquearGenero,
                            onChange: this.onChange,
                            onChangeFecha: this.onChangeFecha,
                            conError: this.conError,
                            pintarSelect: this.pintarSelect,
                        }}
                    />
                )
            case 1:
                return (
                    <Contacto
                        {...{
                            lugar_procedencia,
                            direccion,
                            barrio,
                            estado_civil,
                            estado_civil_opciones,
                            sisben_opciones,
                            grupo_priorizado,
                            otro_grupo, 
                            onChange: this.onChange,
                            conError: this.conError,
                            pintarSelect: this.pintarSelect,
                            pintarSelectOpciones: this.pintarSelectOpciones

                        }}
                    />
                )
            case 2:
                return (
                    <Preferencias
                        {...{
                            semestre,
                            horario_1,
                            horario_2,
                            modalidad,
                            sesiones,
                            motivo,
                            dia_1,
                            hora_i_1,
                            hora_f_1,
                            dia_2,
                            hora_i_2,
                            hora_f_2,
                            dia_semana_opciones,
                            sesiones_opciones,
                            contacto_emergencia,
                            nombre_contacto_emergencia,
                            parentesco,
                            onChange: this.onChange,
                            onChangeTime: this.onChangeTime,
                            conError: this.conError,
                            pintarSelect: this.pintarSelect,
                            pintarSelectOpciones: this.pintarSelectOpciones
                        }}
                    />
                )
            default:
                return <TareasTerminadas imagen={emma_w} mensaje='Esta bandeja esta vacía' widthImg='10%' marginTop='10%' />
        }
    }


    formEstudianteCrisis = () => {
        let { nombre_estudiante, identificacion, celular, correo, contacto_emergencia, motivo, nombre_contacto_emergencia } = this.state

        return <Grid container spacing={3} style={{ marginTop: 10 }}>
            <Grid item xs={12} md={6}><TextField fullWidth label="Nombre del estudiante" value={nombre_estudiante} InputProps={{ readOnly: true }} disabled={true} /></Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Número de identificación" value={identificacion} InputProps={{ readOnly: true }} disabled={true} /></Grid>
            <Grid item xs={12} md={6}><TextField type="number" fullWidth label="Número de celular" name="celular" value={celular.valor} onChange={this.onChange} error={this.conError(celular.error)} helperText={celular.error} /></Grid>
            <Grid item xs={12} md={6}><TextField type="email" fullWidth label="Correo electrónico" name="correo" value={correo.valor} onChange={this.onChange} error={this.conError(correo.error)} helperText={correo.error} /></Grid>
            <Grid item xs={12}>{this.pintarSelect("Programa Academico", "programa")}</Grid>
            <Grid item xs={12}><TextField fullWidth multiline rows={4} label="Escribe el motivo de la solicitud" name="motivo" value={motivo.valor} onChange={this.onChange} error={this.conError(motivo.error)} helperText={motivo.error} /></Grid>
            <Grid item xs={12}><TextField type="text" fullWidth label="Contacto de emergencia" name="nombre_contacto_emergencia" value={nombre_contacto_emergencia.valor} onChange={this.onChange} error={this.conError(nombre_contacto_emergencia.error)} helperText={nombre_contacto_emergencia.error} /></Grid>
            <Grid item xs={12} md={6}><TextField type="number" fullWidth label="Número de contacto de emergencia" name="contacto_emergencia" value={contacto_emergencia.valor} onChange={this.onChange} error={this.conError(contacto_emergencia.error)} helperText={contacto_emergencia.error} /></Grid>
            <Grid item xs={12} md={6}>{this.pintarSelect("Parentesco contacto de emergencia", "parentesco")}</Grid>
        </Grid>
    }

    formRemision = () => {
        let {
            nombre_estudiante,
            identificacion,
            celular,
            correo,
            contacto_emergencia,
            nombre_contacto_emergencia,
            motivo,
            nombre_remitente,
            tipoServicioSel,
            estudiante_seleccionado,
            programa,
            programa_opciones,
        } = this.state
        const programaSinOpciones = Array.isArray(programa_opciones) && programa_opciones.length === 0;
        const programaBloqueado = !estudiante_seleccionado || programaSinOpciones;
        const opcionesPrograma = this.mapSimple(programa_opciones);
        return <Grid container spacing={3} style={{ marginTop: 10 }}>
        {tipoServicioSel?.codigo === COD_CRISIS && (
            <Grid item xs={12}>
                <Typography style={{ color: '#d32f2f', fontWeight: 500 }}>
                ⚠️ En situaciones de crisis, los campos de contacto de emergencia NO son obligatorios. 
                </Typography>
            </Grid>
            )}
            <Grid item xs={12} md={6} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <TextField fullWidth label="Nombre del estudiante" value={nombre_estudiante} InputProps={{ readOnly: true }} disabled={true} />
                <IconButton color="primary" aria-label="Buscar estudiante" onClick={() => this.setState({ openBuscarEstudiante: true })}>
                    <SearchIcon />
                </IconButton>
            </Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Número de identificación" value={identificacion} InputProps={{ readOnly: true }} disabled={true} /></Grid>
            <Grid item xs={12} md={6}><TextField type="number" fullWidth label="Número de celular" name="celular" value={celular.valor} onChange={this.onChange} error={this.conError(celular.error)} helperText={celular.error} /></Grid>
            <Grid item xs={12} md={6}><TextField type="email" fullWidth label="Correo electrónico" name="correo" value={correo.valor} onChange={this.onChange} error={this.conError(correo.error)} helperText={correo.error} /></Grid>
            <Grid item xs={12} md={6}>
                <FormControl className="form-control" error={this.conError(programa.error)}>
                    <InputLabel shrink>Programa Academico</InputLabel>
                    <Select
                        value={programa.valor || ""}
                        onChange={this.onChange}
                        name="programa"
                        disabled={programaBloqueado}
                        displayEmpty
                    >
                        {!estudiante_seleccionado && (
                            <MenuItem value="" disabled>
                                Selecciona el estudiante en la lupa
                            </MenuItem>
                        )}
                        {estudiante_seleccionado && programaSinOpciones && (
                            <MenuItem value="" disabled>
                                El estudiante no tiene programas asignados
                            </MenuItem>
                        )}
                        {opcionesPrograma.map(op => <MenuItem key={op.id} value={op.id}>{op.nombre}</MenuItem>)}
                    </Select>
                    {programa.error && <FormHelperText>{programa.error}</FormHelperText>}
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>{this.pintarSelect("¿Qué tipo de relación tiene con el estudiante?", "relacion")}</Grid>
            <Grid item xs={12} md={6}>{this.pintarSelect("Nivel de prioridad", "nivel_prioridad")}</Grid>
            <Grid item xs={12} md={6}><TextField fullWidth label="Nombre del remitente" name="nombre_remitente" value={nombre_remitente.valor} InputProps={{ readOnly: true }} disabled={true} error={this.conError(nombre_remitente.error)} helperText={nombre_remitente.error} /></Grid>
            <Grid item xs={12}><TextField fullWidth multiline rows={4} label="Descripción del motivo de la remisión" name="motivo" value={motivo.valor} onChange={this.onChange} error={this.conError(motivo.error)} helperText={motivo.error} /></Grid>
            <Grid item xs={12}><TextField fullWidth label="Nombre del contacto de emergencia" name="nombre_contacto_emergencia" value={nombre_contacto_emergencia.valor} onChange={this.onChange} error={this.conError(nombre_contacto_emergencia.error)} helperText={nombre_contacto_emergencia.error} /></Grid>
            <Grid item xs={12} md={6}><TextField type="number" fullWidth label="Número de contacto de emergencia" name="contacto_emergencia" value={contacto_emergencia.valor} onChange={this.onChange} error={this.conError(contacto_emergencia.error)} helperText={contacto_emergencia.error} /></Grid>
            <Grid item xs={12} md={6}>{this.pintarSelect("Parentesco contacto de emergencia", "parentesco")}</Grid>

            <Dialog fullWidth maxWidth="sm" open={this.state.openBuscarEstudiante} onClose={() => this.setState({ openBuscarEstudiante: false })}>
                <AppBarModal titulo={'¡ Buscar Estudiante !'} mostrarModal={() => this.setState({ openBuscarEstudiante: false })} titulo_accion="CERRAR" accion={() => this.setState({ openBuscarEstudiante: false })} />
                <DialogContent style={{ padding: 0 }} className='scroll'>
                    <BuscarPersona callback={async (data) => {
                        try {
                            const persona = await obtenerMisDatos(data.id);
                            try {
                                const misDatosSession = await this.datosUsuarioBienestar();
                            } catch (e) {
                                console.warn('No se pudieron obtener datos de sesión para comparar:', e);
                            }

                            const nombreCompleto = `${data.primer_nombre || ''} ${data.primer_apellido || ''} ${data.segundo_apellido || ''}`.trim();
                            const identificacionVal = data.identificacion || persona?.identificacion || '';
                            const rawProgramas = persona?.programas || [];
                            const programas = rawProgramas.map(p => {
                                const candidateId = p.relacion?.id_relacion ?? p.relacion?.id_programa ?? p.relacion?.id ?? p.id_relacion ?? p.id_programa ?? null;
                                const candidateName = p.relacion?.nombre_relacion ?? p.relacion?.nombre ?? p.nombre_relacion ?? p.nombre_programa ?? p.nombre ?? '';
                                return { value: candidateId ?? null, label: candidateName };
                            });
                            const programasNormalizados = programas.map(p => ({ value: String(p.value), label: p.label }));
                            const isRemision = (this.props.tipoSolicitud && this.props.tipoSolicitud.codigo === COD_SOL_REM);
                            this.setState({
                                nombre_estudiante: nombreCompleto,
                                identificacion: identificacionVal,
                                identificacionError: '',
                                estudiante_seleccionado: data.id,
                                programa_opciones: programasNormalizados,
                                programa: { valor: programasNormalizados.length > 0 ? programasNormalizados[0].value : '' },
                                celular: { valor: isRemision ? (persona?.celular || data?.celular || '') : this.state.celular.valor },
                                correo: { valor: isRemision ? (persona?.correo_personal || data?.correo_personal || '') : this.state.correo.valor },
                                openBuscarEstudiante: false,
                            });
                        } catch (err) {
                            const nombreCompleto = `${data.primer_nombre || ''} ${data.primer_apellido || ''} ${data.segundo_apellido || ''}`.trim();
                            const isRemisionFallback = (this.props.tipoSolicitud && this.props.tipoSolicitud.codigo === COD_SOL_REM);
                            this.setState({
                                nombre_estudiante: nombreCompleto,
                                identificacion: data.identificacion || '',
                                identificacionError: '',
                                estudiante_seleccionado: data.id,
                                programa_opciones: [],
                                programa: { valor: '' },
                                celular: { valor: isRemisionFallback ? (data?.celular || '') : this.state.celular.valor },
                                correo: { valor: isRemisionFallback ? (data?.correo_personal || '') : this.state.correo.valor },
                                openBuscarEstudiante: false
                            });
                        }
                    }} />
                </DialogContent>
                <DialogActions>
                    <BtnForm texto="CANCELAR" callback={() => this.setState({ openBuscarEstudiante: false })} />
                </DialogActions>
            </Dialog>
            <Dialog
                open={this.state.openConfirmarCopiaCoordinador}
                onClose={() => this.setState({ openConfirmarCopiaCoordinador: false })}
                maxWidth="sm"
                fullWidth
            >
                <AppBarModal
                    titulo="¿Enviar copia al coordinador?"
                    mostrarModal={() => this.setState({ openConfirmarCopiaCoordinador: false })}
                    titulo_accion=""
                />
                <DialogContent className="scroll">
                    <Typography>
                        ¿Deseas enviar una copia de esta remisión al correo de coordinación de Bienestar?
                    </Typography>
                    <Typography variant="body2" style={{ marginTop: 8 }}>
                        - Si eliges "No", la solicitud se guardará normalmente sin notificar a coordinación.
                    </Typography>
                    <Typography variant="body2">
                        - Si eliges "Sí", se guardará y además se enviará la copia.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <BtnForm texto="NO, GUARDAR SIN COPIA" callback={this.guardarSinCopia} />
                    <BtnForm texto="SÍ, GUARDAR Y ENVIAR COPIA" callback={this.confirmarGuardarConCopia} />
                </DialogActions>
            </Dialog>
        </Grid>
    }

    render() {
        const { modalAddBienestar, mostrarModalAddBienestar, tipoSolicitud } = this.props;
        const { step, cargando, tipoServicioSel, activeStep, titulo_car } = this.state;
        const titulo = (tipoServicioSel && tipoServicioSel.nombre) ? `${tipoServicioSel.nombre} - ${tipoSolicitud.nombre}` : "Elija su Servicio"


        return (
            <Dialog
                fullWidth
                maxWidth={"md"}
                open={!!modalAddBienestar}
                onClose={() => mostrarModalAddBienestar(false)}
            >
                <AppBarModal titulo={titulo.toUpperCase()} mostrarModal={() => mostrarModalAddBienestar(false)} titulo_accion="" />
                <DialogContent className="scroll" style={{ paddingTop: 14 }}>
                    {activeStep == -1 ? this.renderSelectGrid() :

                        cargando ? (
                            <TareasTerminadas mensaje={titulo_car} marginTop="7%" imagen={emma_w} widthImg="7%" cargando={true} />
                        ) : (
                            <Grid container>
                                {(tipoSolicitud.codigo == COD_SOL_PASPE && tipoServicioSel.codigo != COD_CRISIS) && <Grid item xs={12} md={12}>
                                    <Stepper activeStep={activeStep}>
                                        {
                                            configStep.map(label => (
                                                <Step key={label}>
                                                    <StepLabel><p>{label}</p></StepLabel>
                                                </Step>
                                            ))
                                        }
                                    </Stepper>
                                </Grid>}
                                <Grid item xs={12}>
                                    {this.pintarFormulario()}
                                </Grid>
                            </Grid>

                        )
                    }
                </DialogContent>
                <DialogActions>
                    {activeStep !== -1 && !cargando && (
                        <div className="botones-formulario">
                            {(tipoSolicitud.codigo === COD_SOL_REM || tipoServicioSel.codigo === COD_CRISIS) ? (
                                <BtnForm texto="Guardar" callback={this.onSubmit} />
                            ) : (
                                <>
                                    {(activeStep === 1 || activeStep === 2) && (
                                        <BtnForm texto="Atrás" callback={this.handleBack} />
                                    )}
                                    {activeStep === 0 || activeStep === 1 ? (
                                        <BtnForm texto="Siguiente" callback={this.handleNext} />
                                    ) : activeStep === 2 ? (
                                        <BtnForm texto="Guardar" callback={this.onSubmit} />
                                    ) : null}
                                </>
                            )}
                        </div>
                    )}

                    {activeStep == -1 && <BtnForm texto="CANCELAR" callback={() => mostrarModalAddBienestar(false)} />}
                </DialogActions>
            </Dialog>
        );
    }
}

export default BienestarFormAgregar
